import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export const TermsPage = () => {
    const navigate = useNavigate()

    return (
        <div className="min-h-screen bg-[#0a0a0a] text-gray-300 font-sans p-8 md:p-16">
            <div className="max-w-3xl mx-auto">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center gap-2 text-orange-500 font-bold mb-8 hover:underline"
                >
                    <ArrowLeft size={20} /> {t('terms_page.back_to_home')}
                </button>

                <h1 className="text-4xl font-black text-white mb-8">{t('terms_page.title')}</h1>

                <div className="space-y-6 leading-relaxed">
                    <p className="text-sm text-gray-500">{t('terms_page.last_updated')}</p>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">{t('terms_page.sec1_title')}</h2>
                        <p>{t('terms_page.sec1_text')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">{t('terms_page.sec2_title')}</h2>
                        <p>{t('terms_page.sec2_text')}</p>
                        <ul className="list-disc pl-6 space-y-2 mt-2">
                            <li>{t('terms_page.sec2_list1')}</li>
                            <li>{t('terms_page.sec2_list2')}</li>
                            <li>{t('terms_page.sec2_list3')}</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">{t('terms_page.sec3_title')}</h2>
                        <ul className="list-disc pl-6 space-y-2 mt-2">
                            <li dangerouslySetInnerHTML={{ __html: t('terms_page.sec3_list1') }} />
                            <li dangerouslySetInnerHTML={{ __html: t('terms_page.sec3_list2') }} />
                            <li>{t('terms_page.sec3_list3')}</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">{t('terms_page.sec4_title')}</h2>
                        <p>{t('terms_page.sec4_text')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">{t('terms_page.sec5_title')}</h2>
                        <p>{t('terms_page.sec5_text')}</p>
                    </section>

                    <section className="border-t border-white/10 pt-6 mt-8">
                        <h2 className="text-xl font-bold text-white mb-3">{t('terms_page.contact_title')}</h2>
                        <p>{t('terms_page.contact_text')}</p>
                    </section>
                </div>
            </div>
        </div>
    )
}
